import { useEffect } from "react";
import { SERVER_URL } from "@/config/config";
import { SSE_HEADER } from "@/constants/sse";
import { parseRaceFinishedEvent } from "@/helper/race";
import { isPlayersRace } from "../../../model/raceResultSession";
import { RaceFinishedEvent } from "@/types/Racing/RaceFinishedEvent";

const useRaceSSE = (
    account: string,
    onFinish: (event: RaceFinishedEvent) => void,
    onCreateEvent: () => void,
    onCancelledEvent: () => void
) => {
    useEffect(() => {
        const eventSource = new EventSource(`${SERVER_URL}/event/race`);

        eventSource.onmessage = (e) => {
            if (e.data.includes("welcome")) {
                // Handle welcome message if needed
            } else if (e.data.includes("eventName")) {
                const event = JSON.parse(e.data);
                if (event.eventName === SSE_HEADER.RACE.RACE_CANCELLED) {
                    onCancelledEvent();
                } else if (event.eventName === SSE_HEADER.RACE.RACE_FINISHED) {
                    const raceFinishedEvent = parseRaceFinishedEvent(event.data);

                    if (raceFinishedEvent && isPlayersRace(account, raceFinishedEvent)) {
                        onFinish(raceFinishedEvent)
                    }
                } else if (event.eventName === SSE_HEADER.RACE.RACE_CREATED) {
                    onCreateEvent();
                }
            }
        }

        return () => {
            eventSource.close();
        };
    }, [account, onCancelledEvent, onCreateEvent, onFinish])
}

export default useRaceSSE;
